<template>
  <div class="check-work-body">
    <div style="display: flex;flex-direction: row">
      <div style="width: 200px">
        <area-tree @nodeClick="nodeClick1"></area-tree>
      </div>
      <div>
        <div class="search-wrap">
          <el-form :inline="true" >
            <el-form-item>
              <el-input size="mini" placeholder="请输入客户名称/项目名称" v-model="keyword" clearable style="width: 200px"></el-input>
            </el-form-item>
            <el-form-item>
              <el-date-picker
                size="mini"
                v-model="start_month"
                type="month"
                format="yyyy-MM"
                value-format="yyyy-MM"
                placeholder="选择月">
              </el-date-picker> -
              <el-date-picker
                size="mini"
                v-model="end_month"
                type="month"
                format="yyyy-MM"
                value-format="yyyy-MM"
                placeholder="选择月">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-select size="mini" v-model="entry_type_name" placeholder="业务类型" clearable>
                <el-option
                  v-for="item in business_list"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select size="mini" v-model="check_status" placeholder="审核状态">
                <el-option
                  v-for="item in [{'name':'全部','value':''},{'name':'未审','value':'0'},{'name':'已审','value':'1'}]"
                  :key="item.name"
                  :label="item.name"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button size="mini" type="primary" @click="search">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button size="mini" @click="Api.downloadChangeTemplate(search_params)">导出模板</el-button>
            </el-form-item>
            <el-form-item>
              <el-upload :action="upload_url" :on-success="uploadComplete" :file-list="upload_file_list">
                <el-button size="mini">导入修改</el-button>
              </el-upload>
            </el-form-item>
            <el-form-item>
              <el-button size="mini" @click="Api.downloadFinanceChange(search_params)">导出数据</el-button>
            </el-form-item>
            <el-form-item>
              <el-button size="mini" type="success" v-if="multipleSelection.length&&ERP.isPermission(26005002001001)" @click="checkChange(null)">审核</el-button>
            </el-form-item>
          </el-form>
<!--          <el-button size="mini" type="primary" @click="editArticle()" style="margin-right: 5px;" icon="el-icon-plus">添加</el-button>-->

        </div>

        <div class="table-wrap">
          <el-table v-if="pageData" v-loading="loading" :data="pageData.list" @selection-change="handleSelectionChange" height="680px">
            <el-table-column
              v-if="ERP.isPermission(26005002001001)"
              type="selection"
              :selectable="selectable"
              width="55">
            </el-table-column>
<!--            <el-table-column prop="id" label="id" align="center"></el-table-column>-->
            <el-table-column prop="party_a" label="客户名称" align="center" width="200"></el-table-column>
            <el-table-column prop="project_name" label="项目名称" align="center" width="200"></el-table-column>
            <el-table-column prop="entry_type_name" label="业务类型" align="center" width="80"></el-table-column>
            <el-table-column prop="month" label="应收月份" width="100" align="center"></el-table-column>
            <el-table-column prop="amount" label="合同金额" align="center"></el-table-column>
            <el-table-column prop="symbol_name" label="变动原因" align="center" width="200"></el-table-column>
            <el-table-column prop="symbol_amount" label="变动金额" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.symbol_amount!=0&&scope.row.symbol_value=='-'" style="color: #ff3d00">{{ scope.row.symbol_value }} {{scope.row.symbol_amount}}</span>
                <span v-if="scope.row.symbol_amount!=0&&scope.row.symbol_value=='+'" style="color: #28af05">{{ scope.row.symbol_value }} {{scope.row.symbol_amount}}</span>
                <span v-if="scope.row.symbol_amount==0" style="color: #606060">{{scope.row.symbol_amount}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="invoice_amount" label="应收金额" align="center"></el-table-column>
            <el-table-column prop="status" label="是否审核" align="center">
              <template slot-scope="scope">
                <el-tag size="mini" :type="scope.row.check_status > 0 ?'success':'danger'">{{ scope.row.check_status > 0 ? '已审':'未审'}}</el-tag>
              </template>
            </el-table-column>
<!--            <el-table-column prop="paid_amount" label="实收金额" align="center"></el-table-column>-->
            <el-table-column prop="create_time" label="创建时间" align="center" width="100"></el-table-column>
            <el-table-column prop="update_time" label="修改时间" align="center" width="100"></el-table-column>
            <el-table-column label="操作 " align="center" width="400">
              <template slot-scope="scope">
                <el-button type="primary" :disabled="scope.row.check_status > 0" v-if="ERP.isPermission(26005002001002)" size="mini" icon="el-icon-edit" @click="editArticle(scope.row)">变动</el-button>
                <el-button type="success" :disabled="scope.row.check_status > 0" v-if="ERP.isPermission(26005002001001)" size="mini" icon="el-icon-circle-check" @click="checkChange(scope.row)">审核</el-button>
                <el-button type="success" :disabled="scope.row.check_status <= 0" v-if="ERP.isPermission(26005002001001)" size="mini" icon="el-icon-circle-check" @click="checkChange(scope.row)">
                  反审核
                </el-button>
                <el-button size="mini" icon="el-icon-notebook-1" v-if="scope.row.change_id" @click="changeHistory(scope.row.change_id)">变动日志</el-button>
<!--                <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteFinance(scope.row)">删除</el-button>-->
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="pagination-wrap">
          <el-pagination background layout="prev, pager, next" :total="pageData.total*1" :page-size="pageData.pageSize*1" :current-page="pageData.page*1" @current-change="pageChange"></el-pagination>
        </div>
      </div>
    </div>

    <!-- 修改窗口 -->
    <el-dialog title="变动编辑" :visible.sync="dialogVisible" :close-on-click-modal="false" width="600px">

      <div style="max-height: 500px;overflow-y: auto;">
        <el-form :model="form" ref="form" label-width="100px" size="mini" style="margin-right: 50px;">
          <el-form-item label="客户名称" prop="title">
            <el-input class="form-input" disabled v-model="form.party_a" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="项目名称" prop="title">
            <el-input class="form-input" disabled v-model="form.project_name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="业务类型" prop="title">
            <el-input class="form-input" disabled v-model="form.entry_type_name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="应收月份" prop="title">
            <el-input class="form-input" disabled v-model="form.month" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="合同金额" prop="title">
            <el-input class="form-input" disabled v-model="form.amount" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="变动原因" prop="title">
            <el-select v-model="change_symbol_id" placeholder="变动原因" clearable>
              <el-option
                v-for="item in change_symbol_list"
                :key="item.name"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="变动金额" prop="title">
            <el-input class="form-input" v-model="change_amount" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="应收金额" prop="title">
            <el-input class="form-input" :disabled="true" v-model="form.invoice_amount" autocomplete="off"></el-input>
          </el-form-item>

          <el-form-item label="附件" prop="title">
            <upload-files-sysc :host-url="host_url" :upload-url="host_url+'/contract/project/uploadFile'"  :limit="20" v-model="form.files"></upload-files-sysc>
          </el-form-item>

          <el-form-item label="备注" prop="title">
            <el-input
              type="textarea"
              placeholder="请输入内容"
              v-model="form.remarks"
              maxlength="100"
              show-word-limit
            >
            </el-input>
          </el-form-item>

        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" >确 定</el-button>
      </div>
    </el-dialog>

    <operator-log :data_id="logId" data_type="finance_change" :visible="logVisible" @close="logVisible = false;"></operator-log>

  </div>
</template>

<script>

import CommonHelp from "./common/CommonHelp";
import UploadFilesSysc from "./components/UploadFilesSysc";
import AreaTree from "./components/AreaTree";
import OperatorLog from "./components/OperatorLog.vue";
import Api from "./common/Api";
import {Message} from "element-ui";

export default {
  name:"ContractFinance",
  components: {OperatorLog, AreaTree, UploadFilesSysc},
  data () {
    return {
      host_url:"",
      upload_url : '',
      keyword: '',
      loading: false,
      contract_area_id:'',
      pageData:{
        list:[],
        total:0,
        pageSize:20,
        page:1
      },
      pageChannelData:{
        list:[],
        total:0,
        pageSize:20,
        page:1
      },
      dialogVisible:false,
      form:{
        name:"",
        month:"",
        contract_id:"",
        month_key:"",
        amount:"",
        invoice_amount:"",
        paid_amount:"",
        status:"",
        is_end:"",
        is_invoice:"",
        is_paid:"",
        files:"",
        remarks:"",
      },
      uploadUrl:"",
      month_money_list:[],
      project_list:[],
      month_value:"",
      start_month : '',
      end_month : '',
      business_list:[],
      entry_type_name:"",
      multipleSelection:[],
      change_symbol:{},
      change_symbol_id:"",
      change_symbol_value:'-',
      change_amount:0,
      change_symbol_list:[
        {id:1,name:'缺编扣款',value:'-'},
        {id:2,name:'迟到漏打卡扣款',value:'-'},
        {id:3,name:'品质扣款',value:'-'},
        {id:4,name:'其他扣款',value:'-'},
        {id:5,name:'加班补贴',value:'+'},
        {id:6,name:'其他补贴',value:'+'}
      ],
      f_status:"1,2",
      check_status : '',
      // 操作日志
      logVisible : false,
      logId : 0,
      upload_file_list : [],
    }
  },
  created() {
    this.host_url=CommonHelp.getBaseURL();
    this.upload_url = Api.getUploadUrl('/contract/Finance/batchChange')
    this.start_month = CommonHelp.date("YYYY-MM");
    this.end_month = CommonHelp.date("YYYY-MM");
    // this.getList()
    this.getBusinessList()
  },
  activated() {
    this.getList()
  },
  watch: {
    dialogVisible(val) {
      if(val == false) {
        // this.fileList = []
      }
    },
    "form.province_city_ids":function (n) {
      n&&n[0]&&(this.form.province_id=n[0])
      n&&n[1]&&(this.form.city_id=n[1])
      console.log(n)
    },
    "form.contract_area_ids":function (n) {
      console.log(n)
    },
    change_symbol_id(n){
      let change_symbol=this.change_symbol_list.find(ret=>{ return ret.id===n })
      if(change_symbol){
        change_symbol=JSON.parse(JSON.stringify(change_symbol))
        this.change_symbol=change_symbol;
        this.change_symbol_value=change_symbol.value;
      }
    },
    invoice_amount(n){
      this.form.invoice_amount=n;
    }

  },
  computed:{
    Api() {
      return Api
    },
    invoice_account(){
      return this.multipleSelection.reduce(function(total, currentValue, currentIndex){
        total+=(currentValue.invoice_amount*1);
        return total;
      }, 0)
    },
    finance_ids(){
      return this.multipleSelection.map(ret=>{return ret.id;})
    },
    invoice_amount(){
      return Number(this.form.amount)+Number(this.change_symbol_value+this.change_amount);
    },
    search_params(){
      let where={};
      this.keyword&&(where.name=this.keyword);
      this.contract_area_id&&(where.contract_area_ids=this.contract_area_id);
      this.entry_type_name&&(where.entry_type_name=this.entry_type_name);
      // this.month_value&&(where.month=this.month_value);
      where.start_month = this.start_month;
      where.end_month = this.end_month;
      where['f.status']=this.f_status;
      where['check_status']=this.check_status;
      return where;
    },
  },
  methods: {
    getFormData(data) {
      return Object.assign({
        id:'',
        name:"",
        month:"",
        contract_id:"",
        month_key:"",
        amount:"",
        invoice_amount:"",
        paid_amount:"",
        status:"",
        is_end:"",
        is_invoice:"",
        is_paid:"",
        files:"",
        remarks:"",
      }, data)
    },
    search() {
      this.pageData.page = 1
      this.getList()
    },
    getList() {
      var that=this;
      that.loading=true;
      CommonHelp.get("Finance/getList",{
        where:JSON.stringify(this.search_params),
        page: this.pageData.page,
        page_size: this.pageData.pageSize
      },res=>{
        if(res.code) {
          res.data.list.map(ret=>{
            ret.is_end=ret.is_end === 1;
            ret.is_invoice=ret.is_invoice === 1;
            ret.is_paid=ret.is_paid === 1;
            return ret;
          })
          that.pageData=res.data
          setTimeout(function () {
            that.$forceUpdate();
          },200)
        }
        that.loading=false;
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    editArticle(item) {
      if(!item) {
        this.form = this.getFormData({})
      } else {
        this.form = CommonHelp.reObject(item)
      }
      this.getChangeSymbol();
      this.dialogVisible = true
    },

    submitForm(formName) {
      var that=this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.formLoading = true
          let data = Object.assign({}, this.form)
          if(that.change_symbol_id===""){
            that.$message("选择变动原因")
            return false;
          }

          if(that.change_amount < 0){
            that.$message("变动金额不可以为负数")
            return false;
          }
          data.is_end=data.is_end?1:0;
          data.is_invoice=data.is_invoice?1:0;
          data.is_paid=data.is_paid?1:0;
          CommonHelp.post("Finance/save",data,res => {
            that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
            if(res.code) {
              that.setChangeSymbol()
              // that.getList()
            }
            that.formLoading = false
          })
        } else {
          return false;
        }
      });
    },

    setFrom(data){
      var that=this;
      data.is_end=data.is_end?1:0;
      data.status=data.status?1:0;
      data.is_invoice=data.is_invoice?1:0;
      data.is_paid=data.is_paid?1:0;
      CommonHelp.post("Finance/save",data,res => {
        that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
        if(res.code) {
          that.setChangeSymbol()
          that.getList()
        }
      })
    },
    onAreaChange({data,pathData,ids}){
      this.form.province_city=data.mergename;
      this.form.province_city_ids=ids.join(',')
    },
    onContractAreaChange({data,pathData,ids}){
      let adrr=""
      pathData.map((ret,index)=>{
        adrr+=ret.name+(pathData[index+1]?' -> ':'')
      })
      this.form.contract_area=adrr;
      this.form.contract_area_ids=ids.join(',')
    },
    deleteFinance(item){
      var that=this;
      CommonHelp.post("Finance/delete", {id:item.id},res => {
        that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
        if(res.code) {
          that.getList()
        }
      })
    },
    nodeClick1(n){
      this.contract_area_id=n.id;
      this.pageData={
        list:[],
        total:0,
        pageSize:20,
        page:1
      }
      this.getList()
    },
    exportExcel(){
      var that=this;
      let where={};
      this.keyword&&(where.name=this.keyword);
      this.contract_area_id&&(where.contract_area_ids=this.contract_area_id);
      CommonHelp.get("Finance/exportExcel",{
        where:JSON.stringify(where),
        page: this.pageData.page,
        page_size: this.pageData.pageSize
      },res=>{
        if(res.code) {
          window.open(that.host_url + res.data)
        }
      })
    },
    importExcel(){
      var that=this;
      CommonHelp.uploadFile(ret=>{
        // console.log(ret);
        CommonHelp.post("Finance/importExcel",{ file_name:ret },res=>{
          if(res.code) {
            that.getList();
            if(res.data&&res.data.length){
              that.error_show_status=true;
              that.error_list=res.data;
            }
          }else {
            this.$message(res.msg);
          }
        })
      });
    },
    getBusinessList(){
      var that=this;
      CommonHelp.get("Business/getList",{
        page: 1,
        page_size: 100
      },res=>{
        if(res.code) {
          that.business_list=res.data.list
        }
      })
    },
    selectable(row,index){
      return row.check_status < 1;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    checkStatusChange(){
      var that=this;
      that.$confirm('是否确定操作？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        CommonHelp.post("Finance/check_status_change",{ids:that.finance_ids.join(',')},res=>{
          if(res.code) {
            that.getList();
            that.multipleSelection=[];
          }else {
            that.$message({
              type: 'warning',
              message: res.msg||"请求异常"
            });
          }
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消审核'
        });
      });

    },
    setChangeSymbol(){
      var that=this;
      CommonHelp.post("FinanceChange/saveChange",{
        finance_id:that.form.id,
        symbol_id:that.change_symbol.id,
        symbol_name:that.change_symbol.name,
        symbol_value:that.change_symbol.value,
        amount:that.change_amount
      },res=>{
        that.getList();
        that.dialogVisible = false
      })
    },
    getChangeSymbol(){
      var that=this;
      that.change_symbol_id='';
      that.change_symbol_value='-';
      that.change_amount=0;
      that.change_symbol={}
      CommonHelp.get("FinanceChange/get",{
        finance_id:that.form.id
      },res=>{
        if(res.code===1){
          that.change_symbol_id=res.data.symbol_id||"";
          that.change_symbol_value=res.data.symbol_value||'-';
          that.change_amount=res.data.amount||0;
          let change_symbol=that.change_symbol_list.find(ret=>{ return ret.id===that.change_symbol_id });
          if(change_symbol){
            change_symbol=JSON.parse(JSON.stringify(change_symbol))
          }else {
            change_symbol={}
          }
          that.change_symbol=change_symbol;
        }
      })
    },
    checkChange(item){
      if((item instanceof Object)){
        this.multipleSelection=[item];
      }
      this.checkStatusChange();
    },
    // 变动日志
    changeHistory(id){
      this.logVisible = true;
      this.logId = id;
    },
    // 上传成功
    uploadComplete(res){
      if(res.code){
        this.upload_file_list = [];
        this.getList();
        Message.success(res.msg)
      }else{
        Message.error(res.msg);
      }
    }
  }
}
</script>
<style lang="scss" scoped>

@import './common.scss';

.form-input {
  width: 300px;
}
.table-wrap{
  width: calc( 100vw - 120px - 230px );
  overflow-x: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Contract/ContractFinance.vue